export default "__VITE_ASSET__f00205b3__"